import React from 'react'

import { tabClick } from '@cred/react-analytics/events'

import { IS_BANKRATE_IFRAME_ENABLED } from 'utils/featureToggle/toggles'

import PersonalLoanRateTable from '../../personal'
import StudentLoanRateTable from '../../student-loan'
import StudentLoanRefiRateTable from '../../student-loan-refi'
import MortgageRateTable from '../../mortgage'
import HYSRateTable from '../../high-yield-savings'

const verticalsTabMapping = {
  'personal-loan': {
    tabName: 'Personal Loan',
    tabContent: PersonalLoanRateTable,
  },
  'student-loan': {
    tabName: 'Student Loan',
    tabContent: StudentLoanRateTable,
  },
  'student-loan-refi': {
    tabName: 'Student Loan Refi',
    tabContent: StudentLoanRefiRateTable,
  },
  mortgage: {
    tabName: 'Mortgage',
    tabContent: MortgageRateTable,
  },
  'high-yield-savings': {
    tabName: 'Savings',
    tabContent: IS_BANKRATE_IFRAME_ENABLED ? () => <div /> : HYSRateTable,
  },
}

export const getValidVerticals = (verticals) => {
  const validVerticals = Object.keys(verticalsTabMapping)

  return verticals.filter((vertical) => validVerticals.includes(vertical))
}

export const getTabName = (vertical) => verticalsTabMapping[vertical].tabName

export const getTabContent = (vertical, props) => {
  const TabContentComponent = verticalsTabMapping[vertical].tabContent

  return <TabContentComponent {...props} />
}

export const getOptions = (verticals) => {
  const options = []
  verticals.forEach((vertical) => {
    options.push({ value: vertical, label: getTabName(vertical) })
  })
  return options
}

export const onTabClicked =
  (validVerticals, setVertical, trackSnowplowEvent, updateIframe) => (index) => {
    const vertical = validVerticals[index]
    setVertical(vertical)
    trackSnowplowEvent(tabClick, { text: vertical })

    updateIframe(vertical)
  }
